module.exports = __webpack_public_path__ + "static/GrayMiasteczkoSlaskie-8819b29d68fdf2675a13e2b525f5651f.svg";